import {
  FileExcelOutlined,
  SettingOutlined,
  PrinterFilled,
  FilePdfFilled,
  ExclamationCircleFilled,
  PushpinFilled,
  LeftOutlined,
  RightOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
  UpCircleOutlined,
  DownCircleOutlined,
  CalendarOutlined,
  FileImageOutlined,
  UpOutlined,
  DownOutlined,
  PaperClipOutlined
} from '@ant-design/icons';
import { Image } from 'antd';
import logo from 'assets/images/qmir_logo_white.png';
import logo2 from 'assets/images/qmir_logo_black_235x235.png';

export function IconLogo({width='235px'}) {
  return <Image src={logo} width={width} preview={false}/>;
}
export function IconLogoBlack({width='80px'}) {
  return <Image src={logo2} width={width} preview={false}/>;
}
export function IconExcel({ onClick }) {
  return <FileExcelOutlined style={{ color: 'green', fontSize: '20px' }} onClick={onClick} />;
}
export function IconDownloadExcel() {
  return <FileExcelOutlined style={{ color: 'var(--color-qmir-navy)', fontSize: '15px' }} />;
}
export function IconSetting() {
  return <SettingOutlined style={{ fontSize: '15px' }} />;
}
export function IconPrinter() {
  return (
    <PrinterFilled style={{ color: 'var(--color-gray07)', fontSize: '20px' }} />
  );
}
export function IconFileImage({ onClick }) {
  return (
    <FileImageOutlined style={{ color: 'var(--color-blue01)', fontSize: '20px' }} onClick={onClick} />
  );
}
export function IconFilePdf({ onClick }) {
  return (
    <FilePdfFilled style={{ color: 'var(--color-red01)', fontSize: '20px' }} onClick={onClick} />
  );
}
export function IconPdf() {
  return (
    <FilePdfFilled style={{ color: 'var(--color-red01)', fontSize: '15px' }} />
  );
}
export function IconExclamation() {
  return (
    <ExclamationCircleFilled
      style={{ color: 'var(--color-qmir-yellow)', fontSize: '15px' }}
    />
  );
}
export function IconPaperClip() {
  return (
    <PaperClipOutlined />
  )
}
export function IconPin() {
  return (
    <PushpinFilled style={{ color: 'var(--color-red01)', fontSize: '15px' }} />
  );
}
export function IconUp({ onClick }) {
  return (
    <UpOutlined style={{ fontSize: '10px' }} onClick={onClick} />
  )
}
export function IconDown({ onClick }) {
  return (
    <DownOutlined style={{ fontSize: '10px' }}  onClick={onClick} />
  )
}
export function IconLeft() {
  return (
    <LeftOutlined
      style={{
        border: '1px solid var(--color-gray10)',
        width: '28px',
        height: '32px',
        padding: '4px',
        color: 'var(--color-gray09)',
        fontSize: '16px',
      }}
    />
  );
}
export function IconRight() {
  return (
    <RightOutlined
      style={{
        border: '1px solid var(--color-gray10)',
        width: '28px',
        height: '32px',
        padding: '4px',
        color: 'var(--color-gray09)',
        fontSize: '16px',
      }}
    />
  );
}
export function IconCaretUp() {
  return (
    <CaretUpOutlined
      style={{
        width: '11px',
        height: '9px',
        color: 'var(--color-red02)',
        fontSize: '16px',
      }}
    />
  );
}
export function IconCaretDown() {
  return (
    <CaretDownOutlined
      style={{
        width: '11px',
        height: '9px',
        color: 'var(--color-blue02)',
        fontSize: '16px',
      }}
    />
  );
}
export function IconArrowUpCircle({onClick}) {
  return (
    <UpCircleOutlined
      onClick={onClick}
      style={{
        width: '18px',
        height: '18px',
        color: 'var(--color-blue02)',
        fontSize: '16px',
      }}
    />
  );
}
export function IconArrowDownCircle({onClick}) {
  return (
    <DownCircleOutlined
      onClick={onClick}
      style={{
        width: '18px',
        height: '18px',
        color: 'var(--color-blue02)',
        fontSize: '16px',
      }}
    />
  );
}
export function IconCalendarOutlined() {
  return (
    <CalendarOutlined 
    style={{
      width: '25px',
      height: '25px',
      color: 'var(--color-qmir-navy)',
      fontSize: '16px',
    }}
    />
  )
}
